import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import configureStore from "./store/configureStore";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import MainRoutes from "./routes";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
// import { StripeProvider } from 'react-stripe-elements';
// import { STRIPE_PUBLISHABLE_KEY } from './environment';

let { store, persistor } = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/* <StripeProvider apiKey={STRIPE_PUBLISHABLE_KEY}> */}
      <MuiThemeProvider>
        <MainRoutes />
      </MuiThemeProvider>
      {/* </StripeProvider> */}
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js